const AVATAR_SIZE = 52;

const getColumnSize = (percent: number, totalWidth?: number) => {
  if (!totalWidth) {
    return undefined;
  }
  return (totalWidth - AVATAR_SIZE) * percent;
};

export const getColumns = ({ totalWidth }: { totalWidth?: number }) => [
  {
    accessorKey: 'avatar',
    size: AVATAR_SIZE,
    isAvatar: true,
  },
  {
    accessorKey: 'name',
    header: 'Name',
    minSize: 62,
    sx: { pl: 0 },
    size: getColumnSize(0.25, totalWidth),
    enableResizing: true,
  },
  {
    accessorKey: 'percentage',
    header: 'Percentage',
    size: getColumnSize(0.25, totalWidth),
    minSize: 100,
    enableResizing: true,
  },
  {
    accessorKey: 'status',
    header: 'Status',
    size: getColumnSize(0.25, totalWidth),
    minSize: 148,
    enableResizing: true,
  },
  {
    accessorKey: 'ipi',
    header: 'IPI',
    size: getColumnSize(0.25, totalWidth),
  },
  {
    accessorKey: 'gap',
    size: 0,
  },
];
